// Prod
const VMS_URL = "https://cwiapi.cooperwind.online/auth/"; 
const VMS_URL_CONTRACTOR = "https://cwiapi.cooperwind.online/contractor/";
const VMS_URL_REPORT = "https://cwiapi.cooperwind.online/Report/";
const VMS_VISITORS = "https://cwiapi.cooperwind.online/visitor/"; 
const BASE_API = "https://cwiapi.cooperwind.online/";
const BASE_IMAGE_UPLOAD_API = "https://services.cooperwind.online/";
// Doc
const BASE_DOC_UPLOAD = "https://services.cooperwind.online/Fileupload/document";
const BASE_DOCS_API_GET = "https://services.cooperwind.online/uploads/CWIDocs/";
// Img
const BASE_IMG_UPLOAD = "https://services.cooperwind.online/Fileupload/image";
const BASE_IMAGE_API_GET = "https://services.cooperwind.online/uploads/CWIImages/";
const BASE_IMG_DOC_DELETE = "https://services.cooperwind.online/Fileupload/delete";
const QR_SERV_BASE_URL = "https://service.cooperwind.online/";


// QA
// const VMS_URL = "https://qacwiapi.cooperwind.online/auth/"; 
// const VMS_URL_CONTRACTOR = "https://qacwiapi.cooperwind.online/contractor/";
// const VMS_URL_REPORT = "https://qacwiapi.cooperwind.online/Report/";
// const VMS_VISITORS = "https://qacwiapi.cooperwind.online/visitor/"; 
// const BASE_API = "https://qacwiapi.cooperwind.online/";
// const BASE_IMAGE_UPLOAD_API = "https://services.cooperwind.online/";
// // Doc
// const BASE_DOC_UPLOAD = "https://services.cooperwind.online/Fileupload/QAdocument";
// const BASE_DOCS_API_GET = "https://services.cooperwind.online/uploads/QACWIDocs/";
// // Img
// const BASE_IMG_UPLOAD = "https://services.cooperwind.online/Fileupload/QAimage";
// const BASE_IMAGE_API_GET = "https://services.cooperwind.online/uploads/QACWIImages/";
// const BASE_IMG_DOC_DELETE = "https://services.cooperwind.online/Fileupload/QAdelete";
// const QR_SERV_BASE_URL = "https://service.cooperwind.online/";


const CMMS_AADHAR_CHECKIN = "https://services.cooperwind.online/";
const MACHINE_INFO_HTML_API = "https://machineinfo.cooperwind.live/";


export { VMS_URL, VMS_URL_CONTRACTOR, VMS_URL_REPORT, VMS_VISITORS, CMMS_AADHAR_CHECKIN, BASE_API, BASE_DOCS_API_GET, 
    BASE_IMAGE_UPLOAD_API, BASE_IMG_UPLOAD, MACHINE_INFO_HTML_API, BASE_DOC_UPLOAD, BASE_IMAGE_API_GET, BASE_IMG_DOC_DELETE, QR_SERV_BASE_URL};

